
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/components/i18n/language-provider';
import FadeInSection from '@/components/ui/FadeInSection';

const BottomLineSection: React.FC = () => {
  const { t } = useLanguage();

  return (
    <FadeInSection delay={400}>
      <Card className="bg-primary/5 border-primary/20 mb-8">
        <CardContent className="pt-6">
          <h2 className="text-2xl font-bold mb-4">{t('The Bottom Line')}</h2>
          <p className="text-muted-foreground mb-4">
            {t("While Auth0 implements feature restrictions and pricing tiers that can create adoption barriers, Keystle provides enterprise-grade identity management with all features accessible from the start. Keycloak offers powerful open-source capabilities but demands significant technical expertise and customization to achieve the security and usability that Keystle delivers immediately.")}
          </p>
          <p className="font-bold">
            {t('Keystle provides modern identity infrastructure, passwordless authentication by design, and security that grows with your organization.')}
          </p>
        </CardContent>
      </Card>
    </FadeInSection>
  );
};

export default BottomLineSection;
